/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddConsentAutomationGroupDTO } from '../models';
// @ts-ignore
import type { AddConsentAutomationUserDTO } from '../models';
// @ts-ignore
import type { AddConsentScope200Response } from '../models';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { ConsentAcceptPayload } from '../models';
// @ts-ignore
import type { ConsentScopePayload } from '../models';
// @ts-ignore
import type { ConsentUpdatePayload } from '../models';
// @ts-ignore
import type { DeleteConsent200Response } from '../models';
// @ts-ignore
import type { GetMyConsentAutomations200Response } from '../models';
// @ts-ignore
import type { GetMyConsents200Response } from '../models';
// @ts-ignore
import type { GetUserConsentById200Response } from '../models';
// @ts-ignore
import type { SetConsentExpirationDateDTO } from '../models';
/**
 * ConsentApi - axios parameter creator
 */
export const ConsentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint allows the user to accept a consent. The user can also choose to always accept future consents or add an expiration date.
         * @summary Accept a consent
         * @param {string} consentId 
         * @param {ConsentAcceptPayload} consentAcceptPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptConsent: async (consentId: string, consentAcceptPayload: ConsentAcceptPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('acceptConsent', 'consentId', consentId)
            // verify required parameter 'consentAcceptPayload' is not null or undefined
            assertParamExists('acceptConsent', 'consentAcceptPayload', consentAcceptPayload)
            const localVarPath = `/api/nora/consent/{consentId}/accept`
                .replace('{consentId}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentAcceptPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows the current user to auto-accept future consent requests coming from the added groups.
         * @summary Add a group to the consent auto-accept list
         * @param {AddConsentAutomationGroupDTO} addConsentAutomationGroupDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConsentAutomationsGroup: async (addConsentAutomationGroupDTO: AddConsentAutomationGroupDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addConsentAutomationGroupDTO' is not null or undefined
            assertParamExists('addConsentAutomationsGroup', 'addConsentAutomationGroupDTO', addConsentAutomationGroupDTO)
            const localVarPath = `/api/nora/consent/settings/automation/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addConsentAutomationGroupDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows the current user to auto-accept future consent requests coming from the added users.
         * @summary Add a user to the consent auto-accept list
         * @param {AddConsentAutomationUserDTO} addConsentAutomationUserDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConsentAutomationsUser: async (addConsentAutomationUserDTO: AddConsentAutomationUserDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addConsentAutomationUserDTO' is not null or undefined
            assertParamExists('addConsentAutomationsUser', 'addConsentAutomationUserDTO', addConsentAutomationUserDTO)
            const localVarPath = `/api/nora/consent/settings/automation/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addConsentAutomationUserDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows a user to create a new consent scope
         * @summary Add a consent scope
         * @param {string} consentId 
         * @param {ConsentScopePayload} consentScopePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConsentScope: async (consentId: string, consentScopePayload: ConsentScopePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('addConsentScope', 'consentId', consentId)
            // verify required parameter 'consentScopePayload' is not null or undefined
            assertParamExists('addConsentScope', 'consentScopePayload', consentScopePayload)
            const localVarPath = `/api/nora/consent/{consentId}/scope`
                .replace('{consentId}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentScopePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows a user to delete one of their consents.
         * @summary Delete a consent
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConsent: async (consentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('deleteConsent', 'consentId', consentId)
            const localVarPath = `/api/nora/consent/{consentId}`
                .replace('{consentId}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a group from the users auto-accept list.
         * @summary Delete a group from the consent auto-accept list
         * @param {string} consentAutomationGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConsentAutomationGroup: async (consentAutomationGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentAutomationGroupId' is not null or undefined
            assertParamExists('deleteConsentAutomationGroup', 'consentAutomationGroupId', consentAutomationGroupId)
            const localVarPath = `/api/nora/consent/settings/automation/group/{consentAutomationGroupId}`
                .replace('{consentAutomationGroupId}', encodeURIComponent(String(consentAutomationGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a user from the auto-accept list.
         * @summary Delete a user from the consent auto-accept list
         * @param {string} consentAutomationUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConsentAutomationUser: async (consentAutomationUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentAutomationUserId' is not null or undefined
            assertParamExists('deleteConsentAutomationUser', 'consentAutomationUserId', consentAutomationUserId)
            const localVarPath = `/api/nora/consent/settings/automation/user/{consentAutomationUserId}`
                .replace('{consentAutomationUserId}', encodeURIComponent(String(consentAutomationUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disables auto-accept for all future consents requests for the current user.
         * @summary Disable auto-accept of all consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableGlobalConsentAutomation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/consent/settings/automation/global/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enables auto-accept of all future consent requests for the current user.
         * @summary Enable auto-accept of all consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableGlobalConsentAutomation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/consent/settings/automation/global/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allows admins to update expired consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireConsents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/consent/admin/consent-expiration/force-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows the user to see all their automatic consents.
         * @summary List of all automatic consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConsentAutomations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/consent/settings/automation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns a list of all consents for the currently logged in user.
         * @summary List all consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConsents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns all data for a consent id if the user has access to it.
         * @summary Retrieve all data for a consent id
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsentById: async (consentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('getUserConsentById', 'consentId', consentId)
            const localVarPath = `/api/nora/consent/{consentId}`
                .replace('{consentId}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows an admin to override a users consent when having the override:consent permission.
         * @summary Admin override of a users consent
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideConsent: async (consentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('overrideConsent', 'consentId', consentId)
            const localVarPath = `/api/nora/consent/{consentId}/override`
                .replace('{consentId}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows an admin to override a users consent scope if they have the override:consent permission
         * @summary Admin overrides a users consent scope
         * @param {string} consentId 
         * @param {ConsentScopePayload} consentScopePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideConsentScope: async (consentId: string, consentScopePayload: ConsentScopePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('overrideConsentScope', 'consentId', consentId)
            // verify required parameter 'consentScopePayload' is not null or undefined
            assertParamExists('overrideConsentScope', 'consentScopePayload', consentScopePayload)
            const localVarPath = `/api/nora/consent/{consentId}/scope/override`
                .replace('{consentId}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentScopePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint reinvites the user and resets a consent status back to sent
         * @summary Reinvite the user from an existing consent
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reinviteUser: async (consentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('reinviteUser', 'consentId', consentId)
            const localVarPath = `/api/nora/consent/{consentId}/reinvite`
                .replace('{consentId}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint allows the user to reject a consent.
         * @summary Reject a consent
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectConsent: async (consentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('rejectConsent', 'consentId', consentId)
            const localVarPath = `/api/nora/consent/{consentId}/reject`
                .replace('{consentId}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint allows the user to revoke a consent.
         * @summary Revoke a previously accepted consent
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeConsent: async (consentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('revokeConsent', 'consentId', consentId)
            const localVarPath = `/api/nora/consent/{consentId}/revoke`
                .replace('{consentId}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows a user to delete a consent scope.
         * @summary Delete a consent scope
         * @param {string} consentId 
         * @param {string} consentScopeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeConsentScope: async (consentId: string, consentScopeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('revokeConsentScope', 'consentId', consentId)
            // verify required parameter 'consentScopeId' is not null or undefined
            assertParamExists('revokeConsentScope', 'consentScopeId', consentScopeId)
            const localVarPath = `/api/nora/consent/{consentId}/scope/{consentScopeId}`
                .replace('{consentId}', encodeURIComponent(String(consentId)))
                .replace('{consentScopeId}', encodeURIComponent(String(consentScopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows a user to add an expiration date to a consent.
         * @summary Add an expiration date to a consent
         * @param {string} consentId 
         * @param {string} consentScopeId 
         * @param {SetConsentExpirationDateDTO} setConsentExpirationDateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConsentExpirationDate: async (consentId: string, consentScopeId: string, setConsentExpirationDateDTO: SetConsentExpirationDateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('setConsentExpirationDate', 'consentId', consentId)
            // verify required parameter 'consentScopeId' is not null or undefined
            assertParamExists('setConsentExpirationDate', 'consentScopeId', consentScopeId)
            // verify required parameter 'setConsentExpirationDateDTO' is not null or undefined
            assertParamExists('setConsentExpirationDate', 'setConsentExpirationDateDTO', setConsentExpirationDateDTO)
            const localVarPath = `/api/nora/consent/{consentId}/{consentScopeId}/expiration-date`
                .replace('{consentId}', encodeURIComponent(String(consentId)))
                .replace('{consentScopeId}', encodeURIComponent(String(consentScopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setConsentExpirationDateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a consent with a new status
         * @param {string} consentId 
         * @param {ConsentUpdatePayload} consentUpdatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConsent: async (consentId: string, consentUpdatePayload: ConsentUpdatePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('updateConsent', 'consentId', consentId)
            // verify required parameter 'consentUpdatePayload' is not null or undefined
            assertParamExists('updateConsent', 'consentUpdatePayload', consentUpdatePayload)
            const localVarPath = `/api/nora/consent/{consentId}`
                .replace('{consentId}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentUpdatePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConsentApi - functional programming interface
 */
export const ConsentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConsentApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint allows the user to accept a consent. The user can also choose to always accept future consents or add an expiration date.
         * @summary Accept a consent
         * @param {string} consentId 
         * @param {ConsentAcceptPayload} consentAcceptPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptConsent(consentId: string, consentAcceptPayload: ConsentAcceptPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptConsent(consentId, consentAcceptPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.acceptConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows the current user to auto-accept future consent requests coming from the added groups.
         * @summary Add a group to the consent auto-accept list
         * @param {AddConsentAutomationGroupDTO} addConsentAutomationGroupDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addConsentAutomationsGroup(addConsentAutomationGroupDTO: AddConsentAutomationGroupDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addConsentAutomationsGroup(addConsentAutomationGroupDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.addConsentAutomationsGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows the current user to auto-accept future consent requests coming from the added users.
         * @summary Add a user to the consent auto-accept list
         * @param {AddConsentAutomationUserDTO} addConsentAutomationUserDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addConsentAutomationsUser(addConsentAutomationUserDTO: AddConsentAutomationUserDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addConsentAutomationsUser(addConsentAutomationUserDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.addConsentAutomationsUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows a user to create a new consent scope
         * @summary Add a consent scope
         * @param {string} consentId 
         * @param {ConsentScopePayload} consentScopePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addConsentScope(consentId: string, consentScopePayload: ConsentScopePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddConsentScope200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addConsentScope(consentId, consentScopePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.addConsentScope']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows a user to delete one of their consents.
         * @summary Delete a consent
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConsent(consentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteConsent200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConsent(consentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.deleteConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a group from the users auto-accept list.
         * @summary Delete a group from the consent auto-accept list
         * @param {string} consentAutomationGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConsentAutomationGroup(consentAutomationGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConsentAutomationGroup(consentAutomationGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.deleteConsentAutomationGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a user from the auto-accept list.
         * @summary Delete a user from the consent auto-accept list
         * @param {string} consentAutomationUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConsentAutomationUser(consentAutomationUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConsentAutomationUser(consentAutomationUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.deleteConsentAutomationUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disables auto-accept for all future consents requests for the current user.
         * @summary Disable auto-accept of all consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableGlobalConsentAutomation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableGlobalConsentAutomation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.disableGlobalConsentAutomation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enables auto-accept of all future consent requests for the current user.
         * @summary Enable auto-accept of all consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableGlobalConsentAutomation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableGlobalConsentAutomation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.enableGlobalConsentAutomation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Allows admins to update expired consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expireConsents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyConsents200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expireConsents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.expireConsents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows the user to see all their automatic consents.
         * @summary List of all automatic consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyConsentAutomations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyConsentAutomations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyConsentAutomations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.getMyConsentAutomations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint returns a list of all consents for the currently logged in user.
         * @summary List all consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyConsents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyConsents200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyConsents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.getMyConsents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint returns all data for a consent id if the user has access to it.
         * @summary Retrieve all data for a consent id
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserConsentById(consentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserConsentById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserConsentById(consentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.getUserConsentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows an admin to override a users consent when having the override:consent permission.
         * @summary Admin override of a users consent
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideConsent(consentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideConsent(consentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.overrideConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows an admin to override a users consent scope if they have the override:consent permission
         * @summary Admin overrides a users consent scope
         * @param {string} consentId 
         * @param {ConsentScopePayload} consentScopePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideConsentScope(consentId: string, consentScopePayload: ConsentScopePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideConsentScope(consentId, consentScopePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.overrideConsentScope']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint reinvites the user and resets a consent status back to sent
         * @summary Reinvite the user from an existing consent
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reinviteUser(consentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reinviteUser(consentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.reinviteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint allows the user to reject a consent.
         * @summary Reject a consent
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectConsent(consentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectConsent(consentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.rejectConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint allows the user to revoke a consent.
         * @summary Revoke a previously accepted consent
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeConsent(consentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeConsent(consentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.revokeConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows a user to delete a consent scope.
         * @summary Delete a consent scope
         * @param {string} consentId 
         * @param {string} consentScopeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeConsentScope(consentId: string, consentScopeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeConsentScope(consentId, consentScopeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.revokeConsentScope']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows a user to add an expiration date to a consent.
         * @summary Add an expiration date to a consent
         * @param {string} consentId 
         * @param {string} consentScopeId 
         * @param {SetConsentExpirationDateDTO} setConsentExpirationDateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setConsentExpirationDate(consentId: string, consentScopeId: string, setConsentExpirationDateDTO: SetConsentExpirationDateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setConsentExpirationDate(consentId, consentScopeId, setConsentExpirationDateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.setConsentExpirationDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a consent with a new status
         * @param {string} consentId 
         * @param {ConsentUpdatePayload} consentUpdatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConsent(consentId: string, consentUpdatePayload: ConsentUpdatePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserConsentById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConsent(consentId, consentUpdatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.updateConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConsentApi - factory interface
 */
export const ConsentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConsentApiFp(configuration)
    return {
        /**
         * This endpoint allows the user to accept a consent. The user can also choose to always accept future consents or add an expiration date.
         * @summary Accept a consent
         * @param {ConsentApiAcceptConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptConsent(requestParameters: ConsentApiAcceptConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.acceptConsent(requestParameters.consentId, requestParameters.consentAcceptPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows the current user to auto-accept future consent requests coming from the added groups.
         * @summary Add a group to the consent auto-accept list
         * @param {ConsentApiAddConsentAutomationsGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConsentAutomationsGroup(requestParameters: ConsentApiAddConsentAutomationsGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.addConsentAutomationsGroup(requestParameters.addConsentAutomationGroupDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows the current user to auto-accept future consent requests coming from the added users.
         * @summary Add a user to the consent auto-accept list
         * @param {ConsentApiAddConsentAutomationsUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConsentAutomationsUser(requestParameters: ConsentApiAddConsentAutomationsUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.addConsentAutomationsUser(requestParameters.addConsentAutomationUserDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows a user to create a new consent scope
         * @summary Add a consent scope
         * @param {ConsentApiAddConsentScopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConsentScope(requestParameters: ConsentApiAddConsentScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddConsentScope200Response> {
            return localVarFp.addConsentScope(requestParameters.consentId, requestParameters.consentScopePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows a user to delete one of their consents.
         * @summary Delete a consent
         * @param {ConsentApiDeleteConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConsent(requestParameters: ConsentApiDeleteConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteConsent200Response> {
            return localVarFp.deleteConsent(requestParameters.consentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a group from the users auto-accept list.
         * @summary Delete a group from the consent auto-accept list
         * @param {ConsentApiDeleteConsentAutomationGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConsentAutomationGroup(requestParameters: ConsentApiDeleteConsentAutomationGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteConsentAutomationGroup(requestParameters.consentAutomationGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a user from the auto-accept list.
         * @summary Delete a user from the consent auto-accept list
         * @param {ConsentApiDeleteConsentAutomationUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConsentAutomationUser(requestParameters: ConsentApiDeleteConsentAutomationUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteConsentAutomationUser(requestParameters.consentAutomationUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * Disables auto-accept for all future consents requests for the current user.
         * @summary Disable auto-accept of all consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableGlobalConsentAutomation(options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.disableGlobalConsentAutomation(options).then((request) => request(axios, basePath));
        },
        /**
         * Enables auto-accept of all future consent requests for the current user.
         * @summary Enable auto-accept of all consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableGlobalConsentAutomation(options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.enableGlobalConsentAutomation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allows admins to update expired consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireConsents(options?: RawAxiosRequestConfig): AxiosPromise<GetMyConsents200Response> {
            return localVarFp.expireConsents(options).then((request) => request(axios, basePath));
        },
        /**
         * Allows the user to see all their automatic consents.
         * @summary List of all automatic consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConsentAutomations(options?: RawAxiosRequestConfig): AxiosPromise<GetMyConsentAutomations200Response> {
            return localVarFp.getMyConsentAutomations(options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint returns a list of all consents for the currently logged in user.
         * @summary List all consents for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConsents(options?: RawAxiosRequestConfig): AxiosPromise<GetMyConsents200Response> {
            return localVarFp.getMyConsents(options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint returns all data for a consent id if the user has access to it.
         * @summary Retrieve all data for a consent id
         * @param {ConsentApiGetUserConsentByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsentById(requestParameters: ConsentApiGetUserConsentByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserConsentById200Response> {
            return localVarFp.getUserConsentById(requestParameters.consentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows an admin to override a users consent when having the override:consent permission.
         * @summary Admin override of a users consent
         * @param {ConsentApiOverrideConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideConsent(requestParameters: ConsentApiOverrideConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.overrideConsent(requestParameters.consentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows an admin to override a users consent scope if they have the override:consent permission
         * @summary Admin overrides a users consent scope
         * @param {ConsentApiOverrideConsentScopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideConsentScope(requestParameters: ConsentApiOverrideConsentScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.overrideConsentScope(requestParameters.consentId, requestParameters.consentScopePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint reinvites the user and resets a consent status back to sent
         * @summary Reinvite the user from an existing consent
         * @param {ConsentApiReinviteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reinviteUser(requestParameters: ConsentApiReinviteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.reinviteUser(requestParameters.consentId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows the user to reject a consent.
         * @summary Reject a consent
         * @param {ConsentApiRejectConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectConsent(requestParameters: ConsentApiRejectConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.rejectConsent(requestParameters.consentId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows the user to revoke a consent.
         * @summary Revoke a previously accepted consent
         * @param {ConsentApiRevokeConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeConsent(requestParameters: ConsentApiRevokeConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.revokeConsent(requestParameters.consentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows a user to delete a consent scope.
         * @summary Delete a consent scope
         * @param {ConsentApiRevokeConsentScopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeConsentScope(requestParameters: ConsentApiRevokeConsentScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.revokeConsentScope(requestParameters.consentId, requestParameters.consentScopeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows a user to add an expiration date to a consent.
         * @summary Add an expiration date to a consent
         * @param {ConsentApiSetConsentExpirationDateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConsentExpirationDate(requestParameters: ConsentApiSetConsentExpirationDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.setConsentExpirationDate(requestParameters.consentId, requestParameters.consentScopeId, requestParameters.setConsentExpirationDateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a consent with a new status
         * @param {ConsentApiUpdateConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConsent(requestParameters: ConsentApiUpdateConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserConsentById200Response> {
            return localVarFp.updateConsent(requestParameters.consentId, requestParameters.consentUpdatePayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acceptConsent operation in ConsentApi.
 */
export interface ConsentApiAcceptConsentRequest {
    readonly consentId: string

    readonly consentAcceptPayload: ConsentAcceptPayload
}

/**
 * Request parameters for addConsentAutomationsGroup operation in ConsentApi.
 */
export interface ConsentApiAddConsentAutomationsGroupRequest {
    readonly addConsentAutomationGroupDTO: AddConsentAutomationGroupDTO
}

/**
 * Request parameters for addConsentAutomationsUser operation in ConsentApi.
 */
export interface ConsentApiAddConsentAutomationsUserRequest {
    readonly addConsentAutomationUserDTO: AddConsentAutomationUserDTO
}

/**
 * Request parameters for addConsentScope operation in ConsentApi.
 */
export interface ConsentApiAddConsentScopeRequest {
    readonly consentId: string

    readonly consentScopePayload: ConsentScopePayload
}

/**
 * Request parameters for deleteConsent operation in ConsentApi.
 */
export interface ConsentApiDeleteConsentRequest {
    readonly consentId: string
}

/**
 * Request parameters for deleteConsentAutomationGroup operation in ConsentApi.
 */
export interface ConsentApiDeleteConsentAutomationGroupRequest {
    readonly consentAutomationGroupId: string
}

/**
 * Request parameters for deleteConsentAutomationUser operation in ConsentApi.
 */
export interface ConsentApiDeleteConsentAutomationUserRequest {
    readonly consentAutomationUserId: string
}

/**
 * Request parameters for getUserConsentById operation in ConsentApi.
 */
export interface ConsentApiGetUserConsentByIdRequest {
    readonly consentId: string
}

/**
 * Request parameters for overrideConsent operation in ConsentApi.
 */
export interface ConsentApiOverrideConsentRequest {
    readonly consentId: string
}

/**
 * Request parameters for overrideConsentScope operation in ConsentApi.
 */
export interface ConsentApiOverrideConsentScopeRequest {
    readonly consentId: string

    readonly consentScopePayload: ConsentScopePayload
}

/**
 * Request parameters for reinviteUser operation in ConsentApi.
 */
export interface ConsentApiReinviteUserRequest {
    readonly consentId: string
}

/**
 * Request parameters for rejectConsent operation in ConsentApi.
 */
export interface ConsentApiRejectConsentRequest {
    readonly consentId: string
}

/**
 * Request parameters for revokeConsent operation in ConsentApi.
 */
export interface ConsentApiRevokeConsentRequest {
    readonly consentId: string
}

/**
 * Request parameters for revokeConsentScope operation in ConsentApi.
 */
export interface ConsentApiRevokeConsentScopeRequest {
    readonly consentId: string

    readonly consentScopeId: string
}

/**
 * Request parameters for setConsentExpirationDate operation in ConsentApi.
 */
export interface ConsentApiSetConsentExpirationDateRequest {
    readonly consentId: string

    readonly consentScopeId: string

    readonly setConsentExpirationDateDTO: SetConsentExpirationDateDTO
}

/**
 * Request parameters for updateConsent operation in ConsentApi.
 */
export interface ConsentApiUpdateConsentRequest {
    readonly consentId: string

    readonly consentUpdatePayload: ConsentUpdatePayload
}

/**
 * ConsentApi - object-oriented interface
 */
export class ConsentApi extends BaseAPI {
    /**
     * This endpoint allows the user to accept a consent. The user can also choose to always accept future consents or add an expiration date.
     * @summary Accept a consent
     * @param {ConsentApiAcceptConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public acceptConsent(requestParameters: ConsentApiAcceptConsentRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).acceptConsent(requestParameters.consentId, requestParameters.consentAcceptPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows the current user to auto-accept future consent requests coming from the added groups.
     * @summary Add a group to the consent auto-accept list
     * @param {ConsentApiAddConsentAutomationsGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addConsentAutomationsGroup(requestParameters: ConsentApiAddConsentAutomationsGroupRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).addConsentAutomationsGroup(requestParameters.addConsentAutomationGroupDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows the current user to auto-accept future consent requests coming from the added users.
     * @summary Add a user to the consent auto-accept list
     * @param {ConsentApiAddConsentAutomationsUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addConsentAutomationsUser(requestParameters: ConsentApiAddConsentAutomationsUserRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).addConsentAutomationsUser(requestParameters.addConsentAutomationUserDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows a user to create a new consent scope
     * @summary Add a consent scope
     * @param {ConsentApiAddConsentScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addConsentScope(requestParameters: ConsentApiAddConsentScopeRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).addConsentScope(requestParameters.consentId, requestParameters.consentScopePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows a user to delete one of their consents.
     * @summary Delete a consent
     * @param {ConsentApiDeleteConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteConsent(requestParameters: ConsentApiDeleteConsentRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).deleteConsent(requestParameters.consentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a group from the users auto-accept list.
     * @summary Delete a group from the consent auto-accept list
     * @param {ConsentApiDeleteConsentAutomationGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteConsentAutomationGroup(requestParameters: ConsentApiDeleteConsentAutomationGroupRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).deleteConsentAutomationGroup(requestParameters.consentAutomationGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a user from the auto-accept list.
     * @summary Delete a user from the consent auto-accept list
     * @param {ConsentApiDeleteConsentAutomationUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteConsentAutomationUser(requestParameters: ConsentApiDeleteConsentAutomationUserRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).deleteConsentAutomationUser(requestParameters.consentAutomationUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disables auto-accept for all future consents requests for the current user.
     * @summary Disable auto-accept of all consents for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public disableGlobalConsentAutomation(options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).disableGlobalConsentAutomation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enables auto-accept of all future consent requests for the current user.
     * @summary Enable auto-accept of all consents for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public enableGlobalConsentAutomation(options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).enableGlobalConsentAutomation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allows admins to update expired consents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public expireConsents(options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).expireConsents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows the user to see all their automatic consents.
     * @summary List of all automatic consents for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMyConsentAutomations(options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).getMyConsentAutomations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint returns a list of all consents for the currently logged in user.
     * @summary List all consents for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMyConsents(options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).getMyConsents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint returns all data for a consent id if the user has access to it.
     * @summary Retrieve all data for a consent id
     * @param {ConsentApiGetUserConsentByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserConsentById(requestParameters: ConsentApiGetUserConsentByIdRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).getUserConsentById(requestParameters.consentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows an admin to override a users consent when having the override:consent permission.
     * @summary Admin override of a users consent
     * @param {ConsentApiOverrideConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public overrideConsent(requestParameters: ConsentApiOverrideConsentRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).overrideConsent(requestParameters.consentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows an admin to override a users consent scope if they have the override:consent permission
     * @summary Admin overrides a users consent scope
     * @param {ConsentApiOverrideConsentScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public overrideConsentScope(requestParameters: ConsentApiOverrideConsentScopeRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).overrideConsentScope(requestParameters.consentId, requestParameters.consentScopePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint reinvites the user and resets a consent status back to sent
     * @summary Reinvite the user from an existing consent
     * @param {ConsentApiReinviteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reinviteUser(requestParameters: ConsentApiReinviteUserRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).reinviteUser(requestParameters.consentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint allows the user to reject a consent.
     * @summary Reject a consent
     * @param {ConsentApiRejectConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rejectConsent(requestParameters: ConsentApiRejectConsentRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).rejectConsent(requestParameters.consentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint allows the user to revoke a consent.
     * @summary Revoke a previously accepted consent
     * @param {ConsentApiRevokeConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeConsent(requestParameters: ConsentApiRevokeConsentRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).revokeConsent(requestParameters.consentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows a user to delete a consent scope.
     * @summary Delete a consent scope
     * @param {ConsentApiRevokeConsentScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeConsentScope(requestParameters: ConsentApiRevokeConsentScopeRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).revokeConsentScope(requestParameters.consentId, requestParameters.consentScopeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows a user to add an expiration date to a consent.
     * @summary Add an expiration date to a consent
     * @param {ConsentApiSetConsentExpirationDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setConsentExpirationDate(requestParameters: ConsentApiSetConsentExpirationDateRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).setConsentExpirationDate(requestParameters.consentId, requestParameters.consentScopeId, requestParameters.setConsentExpirationDateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a consent with a new status
     * @param {ConsentApiUpdateConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateConsent(requestParameters: ConsentApiUpdateConsentRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).updateConsent(requestParameters.consentId, requestParameters.consentUpdatePayload, options).then((request) => request(this.axios, this.basePath));
    }
}

